module.exports = __webpack_public_path__ + "static/img/foreground.db18ab8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/school-grounds/foreground.svg
// module id = 78
// module chunks = 2